import React from 'react';
import Container from '@mui/material/Container';
import { Grid, Box, Typography, ListItem, List, Link as MuiLink, Stack, Skeleton } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';

import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import { HashLink } from 'react-router-hash-link';
import { mockProductsData } from '../../../mock/productsData';

const FooterWeb = () => {
  const allProducts = mockProductsData;
  const loading = false;
  const numberOfSkeletons = 4;
  // Function to open Google Maps

  const openMap = () => {
    window.open('https://maps.app.goo.gl/WR7YGzpGV4xfZ8nG6?g_st=com.google.maps.preview.copy');
  };

  return (
    <Box px="124px" sx={{ backgroundColor: '#F0F0F0', pt: 3, pb: 3 }}>
      <Container maxWidth="xl">
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={12} sm={4} md={2}>
            <HashLink
              smooth
              to="/estimate#estimate_top"
              className="merri-weather-text-lighter"
              style={{ textDecoration: 'none', color: '#1D1D1DDE', fontSize: '13px' }}
            >
              {' '}
              <img src="/assets/logoFooter.png" alt="Zeal Curtains" style={{ height: 81 }} />
            </HashLink>
          </Grid>

          <Grid item xs={6} sm={4} md={4}>
            <Stack direction="row" gap={6}>
              <List sx={{ pt: '0 !important' }}>
                <ListItem disableGutters sx={{ pt: '0px !important' }}>
                  <HashLink
                    smooth
                    to="/estimate#estimate_top"
                    className="merri-weather-text-lighter"
                    style={{ textDecoration: 'none', color: '#1D1D1DDE', fontSize: '13px', pt: 0 }}
                  >
                    Estimate
                  </HashLink>
                </ListItem>
                <ListItem disableGutters>
                  <HashLink
                    smooth
                    to="/booking#booking_top"
                    className="merri-weather-text-lighter"
                    style={{ textDecoration: 'none', color: '#1D1D1DDE', fontSize: '13px' }}
                  >
                    Booking
                  </HashLink>
                </ListItem>
              </List>

              <List sx={{ pt: '0 !important' }}>
                {loading
                  ? // Show skeletons when loading
                    Array.from(new Array(numberOfSkeletons)).map((_, index) => (
                      <ListItem
                        disableGutters
                        key={index}
                        sx={{
                          fontSize: '13px',
                          color: '#322B2B',
                          height: '24px',
                          pt: '0px !important',
                        }}
                      >
                        <Skeleton variant="text" width={100} height={20} />
                      </ListItem>
                    ))
                  : allProducts?.products?.slice(0, 4).map((product, key) => (
                      <ListItem
                        className="merri-weather-text-lighter"
                        disableGutters
                        key={product.id || key}
                        sx={{ fontSize: '13px', color: '#1D1D1DDE', pt: '0px !important', cursor: 'pointer' }}
                      >
                        <HashLink
                          smooth
                          to="/estimate#estimate_top"
                          state={product?._id}
                          key={key}
                          style={{
                            textDecoration: 'none',
                            fontSize: '13px',
                            color: '#1D1D1DDE',
                            pt: '0px !important',
                            cursor: 'pointer',
                          }}
                        >
                          {product.name}
                        </HashLink>
                      </ListItem>
                    ))}
              </List>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Stack direction="row" gap={2}>
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Follow us on
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
                <MuiLink href="http://www.instagram.com/zealcurtains" target="_blank" rel="noopener" color="inherit">
                  <InstagramIcon sx={{ color: '#322B2B', height: '20px' }} />
                </MuiLink>
                <MuiLink href="http://www.facebook.com/zealcurtains" target="_blank" rel="noopener" color="inherit">
                  <FacebookRoundedIcon sx={{ color: '#322B2B', height: '20px' }} />
                </MuiLink>
              </Box>
            </Stack>
            <Stack direction="row" gap={2}>
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Call us on
              </Typography>
              <Typography
                color="#322B2B"
                variant="body2"
                mb={0.5}
                sx={{ textDecoration: 'underline', letterSpacing: '1px' }}
              >
                +971 58 549 0727
              </Typography>
            </Stack>
            <Stack direction="row" gap={2}>
              <Typography
                sx={{ fontSize: '14px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                mb={1}
                minWidth="120px"
              >
                Visit us in
              </Typography>
              <Typography
                sx={{ fontSize: '13px', color: '#322B2B' }}
                className="merri-weather-text-lighter"
                onClick={openMap}
              >
                <strong className="merri-weather-text-bold">Dubai</strong>
                <br />
                AL KHABAEESI BUILDING,
                <br />
                PLOT NO. 285-0, Makani No. 3229195132, office no.
                <br />
                18-64, Dubai, UAE.
              </Typography>
            </Stack>
          </Grid>
        </Grid>


      </Container>
    </Box>
  );
};

export default FooterWeb;
